

















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Breadcrumb } from '@/models/breadcrumb.model';

@Component
export default class AccountBreadcrumbComponent extends Vue {
  @Prop({
    default: []
  })
  items: Array<Breadcrumb>;
}
